// extracted by mini-css-extract-plugin
module.exports = {"panelTitle":"panel_panelTitle__3P2CU","panelContainer":"panel_panelContainer__3nxjL","children":"panel_children__3LXk9"};